var newsletter = {
    selector: '[data-newsletter]',
    init: function () {
        var self = this,
            $form = $(self.selector);

        $form.each(function () {
            var $this = $(this),
                $button = $form.find('button[type="submit"]'),
                $agreement = $form.find('input[name="agreement"]');

            $this.on('submit', function (e) {
                e.preventDefault();
                self.subscribe(this);
            });

            $agreement.on('change', function () {
                var $this = $(this);

                if ($this.is(':checked')) {
                    $button.attr('disabled', false);
                } else {
                    $button.attr('disabled', true);
                }
            });
        });
    },
    subscribe: function (form) {
        var self = this,
            $form = $(form),
            $emailInput = $form.find('input[name="email"]'),
            $button = $form.find('button[type="submit"]'),
            email = $emailInput.val(),
            data = {
                action: 'mailchimp_subscribe_user',
                email: email,
            };

        if (email.length < 1) {
            $emailInput.focus();
            return false;
        }

        $emailInput.attr('disabled', true);
        $button.attr('disabled', true);

        jQuery.post(themeVars.ajax_url, data, function (response) {
            var buttonDefault = $button.html();

            if (response.success) {
                $emailInput.val(response.data.success_message);
                $form.addClass('form-success');
            } else {
                $emailInput.val(response.data.error_message);
                $form.addClass('form-error');
            }

            setTimeout(function () {
                $emailInput.val('');
                $emailInput.removeAttr('disabled');
                $button.removeAttr('disabled');
                $form.removeClass('success error');
                $emailInput.focus();
            }, 4000);
        });
    },
};

export { newsletter };
